"use client";

import React from "react";
import Image from "next/image";
import styles from "./AboutSuccessSection.module.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   // faPhone,
//   faChartBar,
//   faCodeBranch,
//   faTools,
//   faSmile,
// } from "@fortawesome/free-solid-svg-icons";

import ImgLight from "../../../public/about-img-7.png"; 

const AboutSuccessSection = () => {
  return (
    <section className={styles.sectionSpace}>
      <div className="container">
        {/* =======================
            TOP SECTION
        ======================= */}
        <div className="row g-4 align-items-center">
          {/* Left Images */} 
          {/* Right Content */}
          <div className="col-lg-6">
            <h3 className="mb-4 display-6 fw-medium">Welcome to Temok!</h3>
            <p className="mb-4 fs-5 textPara">
            A global managed cloud and hosting company built for performance, reliability, and absolute peace of mind.<br/> 
             For over a decade, we’ve helped businesses, developers, and enterprises build and scale their digital presence with world-class infrastructure<br/> 
             solutions — from <strong>Managed Cloud, Dedicated Servers,</strong> and <strong>VPS,</strong> to <strong>Domain Registration, Cybersecurity solutions,</strong>  
             and a broad suite of add-on cloud services.<br/>
             Our philosophy is simple: powerful cloud services don’t have to be complicated.
<br/>
We manage the heavy lifting — infrastructure, uptime, optimization, and security — so you can stay focused on growing your business.
            </p>
 
 
            {/* Call Box */}
            {/* <div className="d-flex align-items-center gap-4">
              <div className={`${styles.iconCircle} bg-dark rounded`}>
                <FontAwesomeIcon icon={faPhone} className="text-light fs-3" />
              </div>

              <div className="flex-grow-1">
                <div className="d-flex align-items-center gap-2 mb-1">
                  <div className="d-flex gap-2 align-items-center">
                    <span className={styles.greenDot}></span>
                    <span className="fw-bold">Calls</span>
                  </div>
                  <span className="fs-14">(Last 7 days)</span>
                </div>

                <h4 className="mb-0">+1 718 414 6543</h4>
              </div>
            </div> */}
          </div>


          <div className="col-lg-6">
            <Image src={ImgLight} alt="image" className="img-fluid d-block" /> 
          </div>
        </div>

<div className="text-center">
    <h4 className="textHad display-6 fw-semibold mt-5">Our Story</h4>
    <p className="textPara fs-5 lh-base"> 
Temok was founded with a bold vision: to transform the hosting industry into something more dependable, more human, and more performance-driven. While many companies simply rent servers, Temok set out to build a truly <strong>Managed Hosting</strong> experience.</p>
    <p  className="textPara fs-5 lh-base">From a small engineering-driven team to a global cloud provider serving customers in 150+ countries, our journey has been fueled by one mission — <strong> to deliver world-class cloud services with unmatched support and unbeatable value.</strong></p>
    <p  className="textPara fs-5 lh-base">Today, Temok powers thousands of projects — from small startups and agencies to high-traffic applications and enterprise workloads.</p>
    </div>
      </div>
    </section>
  );
};

export default AboutSuccessSection;
